<!-- NotificationStack.vue -->
<template>
  <div class="notification-stack">
    <NotificationBox
      v-for="(notification, index) in notifications"
      :key="index"
      :type="notification.type"
      :message="notification.message"
      :style="{ '--index': index }"
      @close="removeNotification"
    />
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import notificationStack from '@/i12e/services/notificationStack';
import NotificationBox from '@/presentation/components/overlay/NotificationBox.vue';

const notifications = ref([]);
const dirtyUpdate = ref(false);

// Update notifications when the notificationStack emits an update event
const updateNotifications = () => {
  let notification = notificationStack.popNotification();
  while (notification) {
    notifications.value.push(notification);
    notification = notificationStack.popNotification();
  }
  dirtyUpdate.value = !dirtyUpdate.value;
};

// Subscribe to notificationStack events
onMounted(() => {
  updateNotifications();
  notificationStack.addEventListener(
    'messaging:notification-pushed',
    updateNotifications
  );
});

onBeforeUnmount(() => {
  notificationStack.removeEventListener(
    'messaging:notification-pushed',
    updateNotifications
  );
});

// Remove the latest notification (LIFO)
const removeNotification = () => {
  notifications.value.pop();
};
</script>

<style scoped>
.notification-stack {
  position: fixed;
  bottom: 1rem; /* Stack starts 1rem from the bottom */
  left: 1rem; /* Align stack to the left side of the page */
}

.notification-stack > * {
  position: absolute;
  left: calc(var(--index) * 0.5rem); /* Offset horizontally based on index */
  bottom: calc(var(--index) * 1rem); /* Offset vertically based on index */
  z-index: calc(
    10 + var(--index)
  ); /* Layer notifications with increasing z-index */
  box-shadow: -1px 1px 7px 0 #00000088;
}

/* Optional: add a fade-out effect for dismissed notifications */
.notification-stack > *[data-dismissed='true'] {
  opacity: 0; /* Fade out dismissed notifications */
  pointer-events: none; /* Prevent interaction during animation */
  transition: opacity 0.5s ease; /* Smooth fade-out */
}
</style>
